export const SQL_ROW_LIMIT = 9999;
export const INDEX_COLUMN = "index";
